import { createSelector, createFeatureSelector } from '@ngrx/store';

import * as fromIntegrations from './reducers/integrations.reducer';
import * as fromIntegration from './reducers/integration.reducer';
import * as fromAccountIntegrations from './reducers/account-integrations.reducer';

export interface State {
  integrations: fromIntegrations.State;
  integration: fromIntegration.State;
  accountIntegrations: fromAccountIntegrations.State;
}

export const reducers = {
  integrations: fromIntegrations.reducer,
  integration: fromIntegration.reducer,
  accountIntegrations: fromAccountIntegrations.reducer,
};

const integrationsState = createFeatureSelector<State>('Integrations');

export const getIntegrationsState = createSelector(
  integrationsState,
  (state) => state.integrations,
);
export const getIntegrations = createSelector(
  getIntegrationsState,
  fromIntegrations.selectAll,
);
export const getIsIntegrationsLoading = createSelector(
  getIntegrationsState,
  (state) => state.isLoading,
);

export const getIntegration = createSelector(
  integrationsState,
  (state) => state.integration,
);

export const getIsIntegrationLoading = createSelector(
  getIntegration,
  (state) => state.isLoading,
);

export const getAccountIntegrationsState = createSelector(
  integrationsState,
  (state) => state.accountIntegrations,
);
export const getAccountIntegrations = createSelector(
  getAccountIntegrationsState,
  fromAccountIntegrations.selectAll,
);
export const getIsAccountIntegrationsLoading = createSelector(
  getAccountIntegrationsState,
  (state) => state.isLoading,
);
